import { render, staticRenderFns } from "./Merger.vue?vue&type=template&id=8a4169d6&scoped=true"
import script from "./Merger.vue?vue&type=script&lang=js"
export * from "./Merger.vue?vue&type=script&lang=js"
import style0 from "./Merger.vue?vue&type=style&index=0&id=8a4169d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4169d6",
  null
  
)

export default component.exports